import React, { useState } from "react";
import { Nav, Button } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useDispatch } from "react-redux";
import { getUser } from "../../data/getters";
import { useNavigationGuard } from "../helpers/NavigationGuardContext";
import { useLanguage } from "../helpers/LanguageContext";
import HelpModal from "./HelpModal";
function SideNavigation({ onToggle }) {
  const dispatch = useDispatch();
  const userRole = dispatch(getUser()).role;
  const { guardedNavigate } = useNavigationGuard();
  const [showNav, setShowNav] = useState(true);
  const [selectedTab, setSelectedTab] = useState("dashboard");
  const { t } = useLanguage();
  const [showHelp, setShowHelp] = useState(false);

  const handleSelectTab = (tab) => {
    if (tab !== selectedTab) {
      setSelectedTab(tab);
      guardedNavigate(`/${tab}`);
    }
  };

  const toggleNav = () => {
    setShowNav(!showNav);
    onToggle();
  };
  const [hoveredTab, setHoveredTab] = useState(null);

  const navLinkStyle = (tab) => ({
    fontWeight: selectedTab === tab ? "bold" : "normal",
    height: "3rem",
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    padding: "0 .6rem",
    margin: "0 .25rem",
    color: selectedTab === tab ? "#0d6efd" : "#212529",
    backgroundColor:
      hoveredTab === tab ? "rgba(13,110,253,0.08)" : "transparent",
    boxShadow:
      hoveredTab === tab
        ? "0 8px 20px rgba(0,0,0,.12), 0 2px 6px rgba(0,0,0,.06)"
        : "none",
    borderLeft:
      selectedTab === tab
        ? "3px solid #0d6efd"
        : hoveredTab === tab
          ? "3px solid rgba(13,110,253,.6)"
          : "3px solid transparent",
    transform: hoveredTab === tab ? "translateX(2px)" : "none",
    transition:
      "background-color .16s ease, box-shadow .16s ease, transform .16s ease, color .16s ease, border-color .16s ease",
    cursor: "pointer"
  });

  return (
    <div
      className="d-flex flex-row  "
      style={{
        //color: "#007bff",
        // position: "fixed",
        top: 0,
        left: 0,
        userSelect: "none",
        WebkitUserSelect: "none",
        flexShrink: 0,
        width: showNav ? "12rem" : "3.5rem",
        height: "inherit",
        transition: "width 0.3s",
        borderRight: "1px solid #dee2e6",
        zIndex: 1000,
        paddingTop: "1rem"
      }}
    >
      <HelpModal show={showHelp} onHide={() => setShowHelp(false)} />
      <Nav
        className="flex-column align-items-left"
        style={{ position: "fixed", height: "100vh", display: "flex" }}
      >
        <Nav.Link
          onClick={() => handleSelectTab("dashboard")}
          style={navLinkStyle("dashboard")}
          onMouseEnter={() => setHoveredTab("dashboard")}
          onMouseLeave={() => setHoveredTab(null)}
        >
          {selectedTab === "dashboard" ? (
            <i className="bi-house-fill  me-2"></i>
          ) : (
            <i className="bi bi-house me-2"></i>
          )}
          {showNav ? t("dashboard") : ""}
        </Nav.Link>
        {userRole == "admin" || userRole == "user" ? (
          <Nav.Link
            onClick={() => handleSelectTab("clients")}
            style={navLinkStyle("clients")}
            onMouseEnter={() => setHoveredTab("clients")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            {selectedTab === "clients" ? (
              <i className="bi bi-people-fill me-2"></i>
            ) : (
              <i className="bi bi-people me-2"></i>
            )}

            {showNav ? t("clients") : ""}
          </Nav.Link>
        ) : (
          <></>
        )}
        {userRole == "companyAdmin" || userRole == "admin" ? (
          <Nav.Link
            onClick={() => handleSelectTab("employee")}
            style={navLinkStyle("employee")}
            onMouseEnter={() => setHoveredTab("employee")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            {selectedTab === "employee" ? (
              <i className="bi bi-people-fill me-2"></i>
            ) : (
              <i className="bi bi-people me-2"></i>
            )}

            {showNav ? t("employee") : ""}
          </Nav.Link>
        ) : (
          <></>
        )}
        {userRole == "companyAdmin" ||
        userRole == "companyUser" ||
        userRole == "admin" ? (
          <Nav.Link
            onClick={() => handleSelectTab("users")}
            style={navLinkStyle("users")}
            onMouseEnter={() => setHoveredTab("users")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            {selectedTab === "users" ? (
              <i className="bi bi-people-fill me-2"></i>
            ) : (
              <i className="bi bi-people me-2"></i>
            )}

            {showNav ? t("users") : ""}
          </Nav.Link>
        ) : (
          <></>
        )}
        <Nav.Link
          onClick={() => handleSelectTab("works")}
          style={navLinkStyle("works")}
          onMouseEnter={() => setHoveredTab("works")}
          onMouseLeave={() => setHoveredTab(null)}
        >
          {selectedTab === "works" ? (
            <i className="bi bi-archive-fill me-2"></i>
          ) : (
            <i className="bi bi-archive me-2"></i>
          )}
          {showNav ? t("works") : ""}
        </Nav.Link>
        {userRole == "admin" ? (
          <Nav.Link
            onClick={() => handleSelectTab("scripts")}
            style={navLinkStyle("scripts")}
            onMouseEnter={() => setHoveredTab("scripts")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            {selectedTab === "scripts" ? (
              <i className="bi bi-file-earmark-code-fill me-2"></i>
            ) : (
              <i className="bi bi-file-earmark-code me-2"></i>
            )}
            {showNav ? t("scripts") : ""}
          </Nav.Link>
        ) : (
          <></>
        )}

        {userRole == "companyAdmin" ||
        userRole == "companyUser" ||
        userRole == "admin" ? (
          <>
            <Nav.Link
              onClick={() => handleSelectTab("schedule")}
              style={navLinkStyle("schedule")}
              onMouseEnter={() => setHoveredTab("schedule")}
              onMouseLeave={() => setHoveredTab(null)}
            >
              {selectedTab === "schedule" ? (
                <i className="bi bi-calendar2-week-fill me-2"></i>
              ) : (
                <i className="bi bi-calendar2-week me-2"></i>
              )}
              {showNav ? t("schedule") : ""}
            </Nav.Link>
            <Nav.Link
              onClick={() => handleSelectTab("reports")}
              style={navLinkStyle("reports")}
              onMouseEnter={() => setHoveredTab("reports")}
              onMouseLeave={() => setHoveredTab(null)}
            >
              {selectedTab === "reports" ? (
                <i className="bi bi-bar-chart-fill me-2"></i>
              ) : (
                <i className="bi bi-bar-chart me-2"></i>
              )}
              {showNav ? t("reports") : ""}
            </Nav.Link>
          </>
        ) : (
          <></>
        )}

        <Nav.Link
          onClick={() => handleSelectTab("colors")}
          style={navLinkStyle("colors")}
          onMouseEnter={() => setHoveredTab("colors")}
          onMouseLeave={() => setHoveredTab(null)}
        >
          {selectedTab === "colors" ? (
            <i className="bi bi-palette-fill me-2"></i>
          ) : (
            <i className="bi bi-palette me-2"></i>
          )}
          {showNav ? t("colors") : ""}
        </Nav.Link>
        {userRole == "companyAdmin" ||
        userRole == "companyUser" ||
        userRole == "admin" ? (
          <Nav.Link
            onClick={() => handleSelectTab("millings")}
            style={navLinkStyle("millings")}
            onMouseEnter={() => setHoveredTab("millings")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            {selectedTab === "millings" ? (
              <i className="bi bi-tools me-2"></i>
            ) : (
              <i className="bi bi-tools me-2"></i>
            )}

            {showNav ? t("millings") : ""}
          </Nav.Link>
        ) : (
          <></>
        )}
        {userRole == "admin" ? (
          <Nav.Link
            onClick={() => handleSelectTab("settings")}
            style={navLinkStyle("settings")}
            onMouseEnter={() => setHoveredTab("settings")}
            onMouseLeave={() => setHoveredTab(null)}
          >
            {selectedTab === "settings" ? (
              <i className="bi bi-gear-fill me-2"></i>
            ) : (
              <i className="bi bi-gear me-2"></i>
            )}

            {showNav ? t("settings") : ""}
          </Nav.Link>
        ) : (
          <></>
        )}
        <Nav.Link
          onClick={() => setShowHelp(true)}
          style={navLinkStyle("help")}
          onMouseEnter={() => setHoveredTab("help")}
          onMouseLeave={() => setHoveredTab(null)}
        >
          <i className="bi bi-question-circle me-2"></i>
          {showNav ? t("help") : ""}
        </Nav.Link>
      </Nav>
      <Button
        onClick={toggleNav}
        style={{
          position: "fixed",
          top: "40vh",
          right: showNav ? "-1.2rem" : "-1.1rem",
          transform: "translateY(-50%)",
          zIndex: 1000,
          border: "2px solid",
          borderColor: "#007bff",
          borderRadius: "50%",
          backgroundColor: "#F3F5F7",
          color: "#007bff",
          fontWeight: "900",
          left: showNav ? "10.7rem" : "2.3rem",

          transition: "left 0.3s",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {showNav ? "<" : ">"}
      </Button>
    </div>
  );
}

export default SideNavigation;
